import React from "react"
import { type EntityCategory } from "@digits-graphql/frontend/graphql-bearer"
import { DigitsTooltip } from "@digits-shared/DesignSystem/Tooltip"
import { BalanceToolTip } from "src/frontend/components/Shared/Transactions/Categories/BalanceTooltip"
import { type ExportOptions } from "src/frontend/components/Shared/Transactions/Categories/categoryTableTypes"
import { TableSummary } from "src/frontend/components/Shared/Transactions/Summaries/Header/TableSummary"
import { isProfitAndLossCategory } from "src/shared/helpers/categoryHelper"
import { type HierarchicalDimensionSummaryNode } from "src/shared/helpers/hierarchicalDimensionHelper"

/*
  STYLES
*/

/*
  INTERFACES
*/

interface SummaryProps {
  categorySummary: HierarchicalDimensionSummaryNode<EntityCategory>
  exportOptions?: ExportOptions
}

/*
  COMPONENTS
*/

export const CategorySummary: React.FC<SummaryProps> = ({ categorySummary, exportOptions }) => {
  const { dimension: category, summary } = categorySummary
  const isProfitAndLossCategoryType = React.useMemo(
    () => isProfitAndLossCategory(category.type),
    [category]
  )

  return (
    <DigitsTooltip
      side="top"
      align="end"
      maxWidth={220}
      content={
        <BalanceToolTip category={categorySummary.dimension} summary={categorySummary.summary} />
      }
      disabled={isProfitAndLossCategoryType}
    >
      <TableSummary summary={summary} exportOptions={exportOptions} />
    </DigitsTooltip>
  )
}
